import type {ReactElement} from 'react';
import {FontSizeControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control';
import {BUTTON_SIZES} from '@FormMakerReact/layout/form-maker-right-panel/sectors/submit-button-sector/submit-button-sector.types';
import type {SubmitButtonSizeControlProps} from './submit-button-size-control.types';

export function SubmitButtonSizeControl({component}: SubmitButtonSizeControlProps): ReactElement {
  return <FontSizeControl component={component} sizes={BUTTON_SIZES} />;
}
